import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
})
export class TutorialComponent implements OnInit {

  @Output() exit = new EventEmitter();

  constructor() { }


  ngOnInit() {}


  closeTutorial(){
    this.exit.emit();
  }

  instaFollow(){
    window.open('https://instagram.com/runnergram.app/');
  }

}
